import {
  OrderStatus,
  OrderType as GatewayOrderType,
  SUCCESS_EQUITY_ORDER_RESPONSE,
  TimeInForce,
} from "@/generated/TradingGateway"

import type {
  EquityOrderResponse,
  PlaceEquityOrderRequest,
} from "../TradingGateway"
import {
  LimitOrderRequest,
  MarketOrderRequest,
  Order,
  StopOrderRequest,
} from "./orders"

export enum OrderType {
  MarketOrder = "market",
  LimitOrder = "limit",
  StopOrder = "stop",
  StopLimitOrder = "stop_limit",
}

export const mapRequest = (
  req: MarketOrderRequest | LimitOrderRequest | StopOrderRequest,
): PlaceEquityOrderRequest => {
  let orderType: GatewayOrderType
  let timeInForce: TimeInForce = TimeInForce.Day
  let limitPrice = 0
  let stopPrice = 0

  if (req.type === OrderType.MarketOrder) {
    orderType = GatewayOrderType.Market
  } else if (req.type === OrderType.LimitOrder) {
    orderType = GatewayOrderType.Limit
    timeInForce = req.timeInForce as TimeInForce
    limitPrice = parseFloat(req.limitPrice)
  } else {
    orderType = GatewayOrderType.Stop
    timeInForce = req.timeInForce as TimeInForce
    stopPrice = parseFloat(req.stopPrice)
    if (req.limitPrice) {
      limitPrice = parseFloat(req.limitPrice)
    }
  }

  const qty = parseFloat(req.qty)

  return {
    symbol: req.symbol,
    side: req.side,
    notional: 0,
    qty,
    orderType,
    timeInForce,
    limitPrice,
    stopPrice,
  }
}

const rejectedOrder = (message: string): Order => ({
  type: OrderStatus.Rejected,
  order: {
    clientOrderId: "",
    qty: "",
    symbol: "",
    side: "",
    createdAt: "",
    commission: "",
    status: "",
  },
  error: { type: "error", message },
})

const extractUserMessage = (rawMessage: string): string => {
  const bodyMatch = rawMessage.match(/HTTP response body: (\{.*?\})\n/)
  if (bodyMatch) {
    try {
      const body = JSON.parse(bodyMatch[1]) as { message?: string }
      if (body.message) return body.message
    } catch {
      // fall through to raw message
    }
  }
  return rawMessage
}

export const mapResponse = (response: EquityOrderResponse): Order => {
  if (response.type === SUCCESS_EQUITY_ORDER_RESPONSE) {
    const { id, qty, symbol, side, createdAt, status } = response.payload

    return {
      type: OrderStatus.Accepted,
      order: {
        clientOrderId: id,
        qty: qty.toString(),
        symbol,
        side,
        createdAt:
          createdAt > BigInt(0)
            ? new Date(
                Number(BigInt(createdAt) / BigInt(1_000_000)),
              ).toISOString()
            : new Date().toISOString(),
        commission: "",
        status,
      },
    }
  }
  return rejectedOrder(extractUserMessage(response.payload.message))
}
